angular.module('pipSettings.Page', [
    'ui.router', 
    'pipSettings.Service',
    'pipNav', 
    'pipSelected',
    'pipTranslate',
    'pipSettings.Templates'
    ]);


import './SettingsPage';
import './SettingsPageRoutes';